module.exports = __webpack_public_path__ + "static/media/fal_fal_goo_per_hoi.e7e0bc70.png";